/**
 * HealthCom brand colors. The patient portal is a HealthCom-branded
 * experience — individual clinics' brand colors are intentionally ignored
 * so a multi-clinic patient sees a consistent UI. Mirrors the fixed
 * palette in `healthcom-app/src/styles/index.css`.
 *
 * Defaults in `styles/index.css` use these same hex values for
 * `--primary-color` and `--accent-color`; the constants here are for code
 * paths that override clinic-provided colors coming back from the API.
 */
export const HEALTHCOM_PRIMARY = '#77bd43';
export const HEALTHCOM_ACCENT = '#f49f01';

/**
 * localStorage key for the last clinic's brand colors. Keeps the saved
 * colors across refreshes so the boot script in `index.html` can apply
 * them before React hydrates, avoiding a flash of HealthCom green when
 * the last-viewed clinic had a different brand.
 *
 * **If you change this value, update the matching key in index.html.**
 */
export const CLINIC_COLORS_STORAGE_KEY = 'healthcom-clinic-colors';

/**
 * localStorage key for the clinicId the user last selected. The patient
 * portal no longer uses URL paths to identify the active clinic — instead
 * we persist the chosen clinicId here and read it on mount. Set by the
 * login → clinic-picker flow and by "Switch Clinic"; cleared on logout.
 */
export const SELECTED_CLINIC_ID_STORAGE_KEY = 'healthcom-selected-clinic-id';
